function hamburger(toggledbutton, toggledMenu){
    if(document.querySelector(toggledbutton) !== null){
        const getButton = document.querySelector(toggledbutton);
        const getMenu = document.querySelector(toggledMenu);
        const getLogo = document.querySelector('.header .logo');
        function toogleHam(){
            getButton.classList.toggle('hamburger_active');
            getMenu.classList.toggle('menu_active');
            document.body.classList.toggle('ow-hidden');
            if(getMenu.classList.contains('menu_active')){
                getMenu.addEventListener('scroll', hideScrLogo, false);
            }else{
                getMenu.removeEventListener('scroll', hideScrLogo, false);
                getLogo.style.opacity = 1;
            }
        }

        function hideScrLogo(){
            if(this.scrollTop > 70){
                getLogo.style.opacity = 0;
            }else{
                getLogo.style.opacity = 1;
            }
        }

        getButton.addEventListener('click', toogleHam, false);
    }
}

module.exports = hamburger;